import { Spinner } from "@/modules/shadcn/ui/spinner";
import { Navigate, useParams } from "react-router";
import { useGetModelsQuery } from "../../services";
import { ModelLayout } from "../ModelLayout/ModelLayout";

/**
 * Index route for /projects/:projectId/models — opens the newest model's
 * detail, or the new-version form (with its auto AI suggestion) when the
 * project has no models yet. Gated on isFetching so a post-delete refetch
 * settles before redirecting, never landing on a just-deleted model.
 */
export const ModelIndexRedirect = () => {
  const { projectId } = useParams();
  const { data: models, isFetching, isError } = useGetModelsQuery(
    { projectId: Number(projectId) },
    { skip: !projectId },
  );

  if (isFetching) {
    return (
      <ModelLayout>
        <div className="flex flex-1 items-center justify-center p-10">
          <Spinner className="size-6 text-emerald-700" />
        </div>
      </ModelLayout>
    );
  }
  if (isError || !models || models.length === 0) {
    return <Navigate to="new" replace />;
  }
  // getModels returns ascending createdAt — the last entry is the newest.
  return <Navigate to={String(models[models.length - 1].id)} replace />;
};
